import { LoginWrapper } from './login.styles';
import useMsal from '../../auth/useMsal';

const Login = () => {
    const { loginAzAd } = useMsal();

    return (
        <LoginWrapper>
            <h1>OrcaWeb</h1>
            <div>
                <p>Please click on the button below to enter OrcaWeb.</p>
                <button onClick={loginAzAd}>Sign in</button>
            </div>
        </LoginWrapper>
    );
};

export default Login;
